

export class FuelCalibrationUpdateInput implements IFuelCalibrationUpdateInput {
    /** The auto-generated id of the fuel calibration master */
    fuelCalibrationId!: number;
    /** The auto-generated id of the branch details master */
    branchDetailId!: number;
    /** The auto-generated id of the vehicle details master */
    vehicleDetailsId!: number;
    /** The auto-generated id of the device model port specification master */
    deviceModelPortSpecificationId!: number;
    /** The sensor output unit must be Voltage,Liter,Gallon,percentage */
    sensorOutputUnit!: string;
    /** The conversion factor */
    conversionFactor!: number;
    /** The sensor output unit must be Automatic,Manual */
    calibrationType!: string;
    /** The tank capacity */
    tankCapacity!: number;
    /** The empty tank reading */
    emptyTankReading!: number;
    /** The half tank reading */
    halfTankReading!: number;
    /** The full tank reading */
    fullTankReading!: number;
    /** The filled up liter */
    filledUpLiter!: number;
    /** The range 50 character */
    range!: string;

    constructor(data?: IFuelCalibrationUpdateInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fuelCalibrationId = _data["fuelCalibrationId"];
            this.branchDetailId = _data["branchDetailId"];
            this.vehicleDetailsId = _data["vehicleDetailsId"];
            this.deviceModelPortSpecificationId = _data["deviceModelPortSpecificationId"];
            this.sensorOutputUnit = _data["sensorOutputUnit"];
            this.conversionFactor = _data["conversionFactor"];
            this.calibrationType = _data["calibrationType"];
            this.tankCapacity = _data["tankCapacity"];
            this.emptyTankReading = _data["emptyTankReading"];
            this.halfTankReading = _data["halfTankReading"];
            this.fullTankReading = _data["fullTankReading"];
            this.filledUpLiter = _data["filledUpLiter"];
            this.range = _data["range"];
        }
    }

    static fromJS(data: any): FuelCalibrationUpdateInput {
        data = typeof data === 'object' ? data : {};
        let result = new FuelCalibrationUpdateInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fuelCalibrationId"] = this.fuelCalibrationId;
        data["branchDetailId"] = this.branchDetailId;
        data["vehicleDetailsId"] = this.vehicleDetailsId;
        data["deviceModelPortSpecificationId"] = this.deviceModelPortSpecificationId;
        data["sensorOutputUnit"] = this.sensorOutputUnit;
        data["conversionFactor"] = this.conversionFactor;
        data["calibrationType"] = this.calibrationType;
        data["tankCapacity"] = this.tankCapacity;
        data["emptyTankReading"] = this.emptyTankReading;
        data["halfTankReading"] = this.halfTankReading;
        data["fullTankReading"] = this.fullTankReading;
        data["filledUpLiter"] = this.filledUpLiter;
        data["range"] = this.range;
        return data; 
    }
}

export interface IFuelCalibrationUpdateInput {
    /** The auto-generated id of the fuel calibration master */
    fuelCalibrationId: number;
    /** The auto-generated id of the branch details master */
    branchDetailId: number;
    /** The auto-generated id of the vehicle details master */
    vehicleDetailsId: number;
    /** The auto-generated id of the device model port specification master */
    deviceModelPortSpecificationId: number;
    /** The sensor output unit must be Voltage,Liter,Gallon,percentage */
    sensorOutputUnit: string;
    /** The conversion factor */
    conversionFactor: number;
    /** The sensor output unit must be Automatic,Manual */
    calibrationType: string;
    /** The tank capacity */
    tankCapacity: number;
    /** The empty tank reading */
    emptyTankReading: number;
    /** The half tank reading */
    halfTankReading: number;
    /** The full tank reading */
    fullTankReading: number;
    /** The filled up liter */
    filledUpLiter: number;
    /** The range 50 character */
    range: string;
}

